import { DialogActions } from '@mui/material';
import { getCreditLineAssignations } from 'lib/api';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import { hasAnyPermissions } from 'lib/functions/utils';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AuthState } from 'services/redux/authSlice';

import CreditLineStatus from '../../../../../../../../../common/creditLineStatus';
import ShoppingCartFactoringReviewed from '../2_ShoppingCartReviewed';
import CreditLineConcentrations from '../3_ShoppingCartAssigned/components/Concentrations';

const ShoppingCartFactoringRejected = (props: any) => {
  const {
    setOpenShoppingCart,
    openShoppingCart,
    openRequest,
    setLoading,
    setUp,
    handleDetails,
  } = props;
  const dispatch = useDispatch();
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const [editing, setEditing] = useState(false);
  const [miniLoading, setMiniLoading] = useState(false);
  const [stakeholdersConcentrations, setStakeholdersConcentrations] = useState(
    [],
  );
  const [subProductsConcentrations, setSubProductsConcentrations] = useState(
    [],
  );

  const setUpConcentrations = async () => {
    setMiniLoading(true);
    try {
      const response = await getCreditLineAssignations(dispatch, {
        id: openRequest.id,
      });
      setStakeholdersConcentrations(response.stakeholderAssignations);
      setSubProductsConcentrations(response.subProductAssignations);
    } catch (error) {
      console.error(error);
    }
    setMiniLoading(false);
  };

  useEffect(() => {
    void setUpConcentrations();
  }, []);

  if (editing) {
    return (
      <ShoppingCartFactoringReviewed
        openShoppingCart={openShoppingCart}
        setOpenShoppingCart={setOpenShoppingCart}
        openRequest={openRequest}
        inAssignationDefault
        setUp={setUp}
        handleDetails={handleDetails}
        setLoading={setLoading}
        setEditing={setEditing}
      />
    );
  }

  return (
    <div>
      <div>
        <CreditLineStatus openRequest={openRequest} audienceType="sent" />
        {miniLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <CenteredCircularProgress />
          </div>
        ) : (
          <div>
            <div style={{ padding: '20px 0px 0px' }}>
              <CreditLineConcentrations
                stakeholdersConcentrations={stakeholdersConcentrations}
                subProductsConcentrations={subProductsConcentrations}
                productType={openRequest.productType}
              />
            </div>
          </div>
        )}
        <DialogActions>
          <CustomButton
            onClick={() => setEditing(true)}
            color="primary"
            disabled={!hasAnyPermissions(user, ['financing_creditLine_edit'])}
          >
            Editar
          </CustomButton>
          <CustomButton
            onClick={() => setOpenShoppingCart(false)}
            color="secondary"
          >
            Salir
          </CustomButton>
        </DialogActions>
      </div>
    </div>
  );
};

export default ShoppingCartFactoringRejected;
